import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {EventItem, ProyectoItem} from "../../../../interfaces/proyecto.interface";
import {Location, NgClass, NgIf, NgTemplateOutlet} from "@angular/common";
import {TimelineModule} from "primeng/timeline";
import {TooltipModule} from "primeng/tooltip";
import {RouterLink} from "@angular/router";
import {Button} from "primeng/button";
import {StyleClassModule} from "primeng/styleclass";
import {RandomSessionIdService} from "../../../../../guards/random-session-id.service";
import {TagModule} from "primeng/tag";
import {EvaluacionesService} from "../../../../../officials/evaluaciones/services/evaluaciones.service";
import {
    EvalInterface,
    EvaluacionEstado,
} from "../../../../../officials/evaluaciones/interfaces/evaluaciones.interface";
import {LoginServices} from "../../../../../auth/login/services/login.service";
import CONSTANTS from 'src/utils/resources/constants';

@Component({
    selector: 'app-generales-resumen',
    standalone: true,
    imports: [
        NgClass,
        TimelineModule,
        NgIf,
        TooltipModule,
        StyleClassModule,
        Button,
        RouterLink,
        TagModule,
        NgTemplateOutlet
    ],
    templateUrl: './generales-resumen.component.html',
    styleUrl: './generales-resumen.component.scss'
})
export class GeneralesResumenComponent implements OnInit {
    @Input() timelineEvents: EventItem[] | undefined = [];
    @Input() goBackLabel: string = 'Regresar';
    @Input() btnVerDetalles: boolean = false;
    @Input() carritoButtomTemplate!: TemplateRef<any>;
    @Input() initEvaluacionTemplate!: TemplateRef<any>;
    @Output() itemClickedEval = new EventEmitter<{ evalu: any, event: Event }>();
    sessionId: string | null
    evaluacionInit!: EvalInterface

    protected readonly top = top;
    static aprobada: string = 'Aprobada';
    /** Usualmente definidos para recibir los datos de los inputs */
    private consoleEnabled: boolean = CONSTANTS.consoleEnabled; //environment.showConsole; // Cambiar a false para desactivar los logs de consola
    private _selected: ProyectoItem | null = null;
    /** Usualmente definidos para ser utilizados en el html */
    public is_rp: boolean = false;
    public roles_cliente: string[] = ['cliente_ventanilla'];
    public roles_tecnico: string[] = ['tecnico_resolutor'];
    public roles_not_cliente: string[] = ['ministro', 'gerente', 'jefe', 'receptor'];
    public label_cliente: string = 'Navegar hasta el listado de solicitudes';
    public label_tecnico: string = 'Regresar a sus solicitudes asignadas';
    public label_not_cliente: string = 'Pantalla de asignaciones';
    public path_cliente: string = '/users/registro-profesionales';
    public path_tecnico: string = '/officials/solicitudes-asignadas';
    public path_not_cliente: string = '/officials/asignaciones';
    constructor(
        private location: Location,
        public loginServices: LoginServices,
        private evaluacionesService: EvaluacionesService,
        public randomSessionIdService: RandomSessionIdService,
    ) {
        this.sessionId = randomSessionIdService.randomSessionId();
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }

    @Input()
    set selected(data: ProyectoItem | null) {
        this._selected = data;
        if (data) {
            //onChange detected
            if (this.consoleEnabled) console.log("IS RP:", this.RP(this.selected))
            this.is_rp = this.RP(this.selected)
        }
    }

    get selected(): ProyectoItem | null {
        return this._selected;
    }

    RP(tramite: any): boolean {
        return tramite?.nombre?.startsWith('RP_') === true;
    }

    goBack(): void {
        this.location.back()
    }
    onItemClickedEval(evalu: EvalInterface, event: Event) {
        evalu = {
            idProyecto: this.selected?.idProyecto!, idSolicitud: this.selected?.idSolicitud!,
            usuario: this.loginServices.session()?.perfil.usuario!, idEstado: EvaluacionEstado.Pendiente
        };
        this.itemClickedEval.emit({evalu, event});
    }

}
